export class Email {
  private constructor(private readonly value: string) {
    if (!this.isValid(value)) {
      throw new Error('Invalid email format');
    }
  }

  /**
   * Crea un nuevo Email con validaciones
   */
  static create(email: string): Email {
    return new Email(email);
  }

  /**
   * Reconstruye un Email desde persistencia (sin validaciones)
   * Usar solo cuando el valor ya fue validado previamente
   */
  static fromValue(email: string): Email {
    const emailObj = Object.create(Email.prototype);
    (emailObj as any).value = email;
    return emailObj;
  }

  private isValid(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  getValue(): string {
    return this.value;
  }

  equals(other: Email): boolean {
    return this.value === other.value;
  }
}
